export const Crops = [
  { value: 'Amendoim', label: 'Amendoim' },
  { value: 'Café', label: 'Café' },
  { value: 'Cana', label: 'Cana' },
  { value: 'Feijão', label: 'Feijão' },
  { value: 'Milho', label: 'Milho' },
  { value: 'Soja', label: 'Soja' },
  { value: 'Trigo', label: 'Trigo' },
]